angular.module('billing').controller('ReceiptModalCtrl',
    ['$scope', '$uibModalInstance', '$window', 'BillingService', '$sce', 'loginUserId', 'txId',
        function ($scope, $modalInstance, $window, BillingService, $sce, loginUserId, txId) {
            'use strict';

            $scope.loadingReceipt = true;
            $scope.model = {
                ReceiptHtml: ''
            };

            function loadReceipt() {
                var receiptRequestDto = {
                    TxId: txId,
                    RecipientEnumText: 'CUST',
                    LoginUserPatientId: loginUserId,
                    RemoteSessionId: loginUserId + new Date().toLocaleDateString()
                };

                BillingService.getReceiptHtml(receiptRequestDto)
                    .then(function (data) {
                        if (data) {
                            $scope.model.ReceiptHtml = $sce.trustAsHtml(data.ReceiptHtml);
                        }
                    })
                    .finally(function () {
                        $scope.loadingReceipt = false;
                    });
            }

            function ok() {
                $modalInstance.close('ok');
            }

            function cancel() {
                $modalInstance.dismiss('cancel');
            }

            function print() {
                $window.print();
            }

            $scope.print = print;
            $scope.ok = ok;
            $scope.cancel = cancel;

            loadReceipt();
        }]);
